var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useTheme } from 'react-jss';
import useStyles from './styles';
import clsx from 'clsx';
const Button = (_a) => {
    var { customClassName = '', inlineStyles = {}, color = 'primary', variant = 'text', uppercase = true, disabled = false, children, onClick } = _a, rest = __rest(_a, ["customClassName", "inlineStyles", "color", "variant", "uppercase", "disabled", "children", "onClick"]);
    const theme = useTheme();
    const classes = useStyles({ theme });
    const buttonStyle = clsx({
        [classes.button]: true,
        [classes[`${variant}-${color}`]]: true,
        [classes.uppercase]: uppercase,
        [classes[`${variant}-disabled`]]: disabled,
        [customClassName]: Boolean(customClassName),
    });
    return (React.createElement("button", Object.assign({ className: buttonStyle, style: inlineStyles, disabled: disabled, onClick: onClick }, rest), children));
};
export { Button };
//# sourceMappingURL=Button.js.map